import { render, staticRenderFns } from "./PaginatedEditorList.vue?vue&type=template&id=2f0fa77c"
import script from "./PaginatedEditorList.vue?vue&type=script&lang=ts"
export * from "./PaginatedEditorList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports